// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

import React from 'react';
import { useIntl } from 'react-intl';
import { MESSAGE_COPYRIGHT, MESSAGE_PRIVACY } from '../constants/constants';

function PageFooter () {
	const intl = useIntl();

	const privacyLabel = intl.formatMessage({
		id: 'messages.PRIVACY',
		defaultMessage: MESSAGE_PRIVACY
	});

	const copyrightMessage = intl.formatMessage({
		id: 'messages.COPYRIGHT',
		defaultMessage: MESSAGE_COPYRIGHT.replace('{date}', new Date().getFullYear())
	}, { date: new Date().getFullYear() });

	return (
		<div className="slds-align_absolute-center sticky-footer">
			<ul className="slds-list_horizontal slds-has-dividers_left">
				<li className="slds-item">
					{copyrightMessage}
				</li>
				<li className="slds-item">
					<a href="https://www.salesforce.com/company/privacy/?mc=marketingcloud.com/privacy-policy" target="_blank" rel="noopener noreferrer">
						{privacyLabel}
					</a>
				</li>
			</ul>
		</div>
	);
}

export default PageFooter;
